import { Fuel, TopupHistoryItem } from '@/src/api/payg/types';
import { ASC_LABEL } from '@/src/components/payg/utils/topupCopy';
import { formatWeekdayWithOrdinal } from '@/src/utils/date';
import { Action, Badge, Icon, Strong } from '@ovotech/element-v5';
import React from 'react';
import { formatTopupAmount, getTopupPresentation } from '../utils';
import {
  Amount,
  AmountColumn,
  FuelIcon,
  RowContainer,
  TopupType,
  TransactionDate,
  TransactionDetails,
  ViewLink,
} from './TopupHistoryItemRow.styled';

type Props = {
  item: TopupHistoryItem;
  /** Optional: a historical top-up's meter may no longer be in the balances. */
  fuel?: Fuel;
  onClickView: (item: TopupHistoryItem) => void;
};

export const TopupHistoryItemRow = ({ item, fuel, onClickView }: Props) => {
  const { statusLabel, statusVariant, showPlus } = getTopupPresentation(item);
  const amount = `${showPlus ? '+' : ''}${formatTopupAmount(
    item.amountInPence,
  )}`;

  return (
    <RowContainer>
      {fuel && (
        <FuelIcon>
          <Icon name={fuel === Fuel.GAS ? 'gas' : 'electricity'} size={24} />
        </FuelIcon>
      )}

      <TransactionDetails>
        {fuel && <Strong>{fuel}</Strong>}
        <TransactionDate>
          {formatWeekdayWithOrdinal(item.transactionDateTime)}
        </TransactionDate>
        {statusLabel && <Badge variant={statusVariant}>{statusLabel}</Badge>}
      </TransactionDetails>

      <AmountColumn>
        <Amount>{amount}</Amount>
        {item.topupType === 'asc' && <TopupType>{ASC_LABEL}</TopupType>}
      </AmountColumn>
      <ViewLink>
        <Action
          iconRight="chevron-right-small"
          onClick={() => onClickView(item)}
        >
          View
        </Action>
      </ViewLink>
    </RowContainer>
  );
};
